/**
 * Bump this when you replace files under public/products/ so clients bypass cached images.
 * Optional override: VITE_PRODUCT_IMAGES_VERSION in .env
 */
export const PRODUCT_IMAGES_CACHE_VERSION = '33'

export function productImageUrl(path: string): string {
  if (!path.startsWith('/products/')) return path
  const v = import.meta.env.VITE_PRODUCT_IMAGES_VERSION ?? PRODUCT_IMAGES_CACHE_VERSION
  const sep = path.includes('?') ? '&' : '?'
  const safePath = encodeURI(path)
  return `${safePath}${sep}v=${encodeURIComponent(String(v))}`
}

/** For server (checkout, emails): absolute URL with cache param. */
export function absoluteProductImageUrl(
  path: string,
  siteOrigin: string,
): string {
  const base = siteOrigin.replace(/\/$/, '')
  const withQuery = productImageUrl(path)
  return `${base}${withQuery}`
}
